import SuperAdminUsers from "./users";


export const SuperAdminUsersPage = SuperAdminUsers;

